var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex, Collection, Browser } from '@syncfusion/ej2-base';
/**
 * Defines the appearance of the connectors
 */
var Connector = /** @class */ (function (_super) {
    __extends(Connector, _super);
    function Connector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('Line')
    ], Connector.prototype, "type", void 0);
    __decorate([
        Property(null)
    ], Connector.prototype, "color", void 0);
    __decorate([
        Property(1)
    ], Connector.prototype, "width", void 0);
    __decorate([
        Property(null)
    ], Connector.prototype, "length", void 0);
    __decorate([
        Property('')
    ], Connector.prototype, "dashArray", void 0);
    return Connector;
}(ChildProperty));
export { Connector };
/**
 * Configures the fonts in charts.
 */
var Font = /** @class */ (function (_super) {
    __extends(Font, _super);
    function Font() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('Normal')
    ], Font.prototype, "fontStyle", void 0);
    __decorate([
        Property('16px')
    ], Font.prototype, "size", void 0);
    __decorate([
        Property('Normal')
    ], Font.prototype, "fontWeight", void 0);
    __decorate([
        Property('')
    ], Font.prototype, "color", void 0);
    __decorate([
        Property('Center')
    ], Font.prototype, "textAlignment", void 0);
    __decorate([
        Property('Segoe UI')
    ], Font.prototype, "fontFamily", void 0);
    __decorate([
        Property(1)
    ], Font.prototype, "opacity", void 0);
    __decorate([
        Property('Wrap')
    ], Font.prototype, "textOverflow", void 0);
    return Font;
}(ChildProperty));
export { Font };
/**
 * Configures the borders in the chart.
 */
var Border = /** @class */ (function (_super) {
    __extends(Border, _super);
    function Border() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('')
    ], Border.prototype, "color", void 0);
    __decorate([
        Property(1)
    ], Border.prototype, "width", void 0);
    return Border;
}(ChildProperty));
export { Border };
/**
 * Configures the marker position in the chart.
 */
var Offset = /** @class */ (function (_super) {
    __extends(Offset, _super);
    function Offset() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(0)
    ], Offset.prototype, "x", void 0);
    __decorate([
        Property(0)
    ], Offset.prototype, "y", void 0);
    return Offset;
}(ChildProperty));
export { Offset };
/**
 * Configures the chart area.
 */
var ChartArea = /** @class */ (function (_super) {
    __extends(ChartArea, _super);
    function ChartArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Complex({}, Border)
    ], ChartArea.prototype, "border", void 0);
    __decorate([
        Property('transparent')
    ], ChartArea.prototype, "background", void 0);
    __decorate([
        Property(1)
    ], ChartArea.prototype, "opacity", void 0);
    __decorate([
        Property(null)
    ], ChartArea.prototype, "backgroundImage", void 0);
    __decorate([
        Property(null)
    ], ChartArea.prototype, "width", void 0);
    return ChartArea;
}(ChildProperty));
export { ChartArea };
/**
 * Configures the chart margins.
 */
var Margin = /** @class */ (function (_super) {
    __extends(Margin, _super);
    function Margin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(Browser.isDevice ? 5 : 10)
    ], Margin.prototype, "left", void 0);
    __decorate([
        Property(Browser.isDevice ? 5 : 10)
    ], Margin.prototype, "right", void 0);
    __decorate([
        Property(Browser.isDevice ? 5 : 10)
    ], Margin.prototype, "top", void 0);
    __decorate([
        Property(Browser.isDevice ? 5 : 10)
    ], Margin.prototype, "bottom", void 0);
    return Margin;
}(ChildProperty));
export { Margin };
/**
 * Configures the chart Legend Container Padding.
 */
var ContainerPadding = /** @class */ (function (_super) {
    __extends(ContainerPadding, _super);
    function ContainerPadding() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(0)
    ], ContainerPadding.prototype, "left", void 0);
    __decorate([
        Property(0)
    ], ContainerPadding.prototype, "right", void 0);
    __decorate([
        Property(0)
    ], ContainerPadding.prototype, "top", void 0);
    __decorate([
        Property(0)
    ], ContainerPadding.prototype, "bottom", void 0);
    return ContainerPadding;
}(ChildProperty));
export { ContainerPadding };
/**
 * Configures the animation behavior for chart series.
 */
var Animation = /** @class */ (function (_super) {
    __extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(true)
    ], Animation.prototype, "enable", void 0);
    __decorate([
        Property(1000)
    ], Animation.prototype, "duration", void 0);
    __decorate([
        Property(0)
    ], Animation.prototype, "delay", void 0);
    return Animation;
}(ChildProperty));
export { Animation };
/**
 * Series and point index
 *
 * @public
 */
var Indexes = /** @class */ (function (_super) {
    __extends(Indexes, _super);
    function Indexes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(0)
    ], Indexes.prototype, "series", void 0);
    __decorate([
        Property(0)
    ], Indexes.prototype, "point", void 0);
    return Indexes;
}(ChildProperty));
export { Indexes };
/**
 * Column series rounded corner options
 */
var CornerRadius = /** @class */ (function (_super) {
    __extends(CornerRadius, _super);
    function CornerRadius() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(0)
    ], CornerRadius.prototype, "topLeft", void 0);
    __decorate([
        Property(0)
    ], CornerRadius.prototype, "topRight", void 0);
    __decorate([
        Property(0)
    ], CornerRadius.prototype, "bottomLeft", void 0);
    __decorate([
        Property(0)
    ], CornerRadius.prototype, "bottomRight", void 0);
    return CornerRadius;
}(ChildProperty));
export { CornerRadius };
/**
 * @private
 */
var Index = /** @class */ (function () {
    function Index(seriesIndex, pointIndex) {
        this.series = seriesIndex;
        this.point = pointIndex;
    }
    return Index;
}());
export { Index };
/**
 * Configures the Empty Points of series
 */
var EmptyPointSettings = /** @class */ (function (_super) {
    __extends(EmptyPointSettings, _super);
    function EmptyPointSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(null)
    ], EmptyPointSettings.prototype, "fill", void 0);
    __decorate([
        Complex({ color: 'transparent', width: 0 }, Border)
    ], EmptyPointSettings.prototype, "border", void 0);
    __decorate([
        Property('Gap')
    ], EmptyPointSettings.prototype, "mode", void 0);
    return EmptyPointSettings;
}(ChildProperty));
export { EmptyPointSettings };
/**
 * Configures the drag settings of series
 */
var DragSettings = /** @class */ (function (_super) {
    __extends(DragSettings, _super);
    function DragSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(false)
    ], DragSettings.prototype, "enable", void 0);
    __decorate([
        Property(null)
    ], DragSettings.prototype, "minY", void 0);
    __decorate([
        Property(null)
    ], DragSettings.prototype, "maxY", void 0);
    __decorate([
        Property(null)
    ], DragSettings.prototype, "fill", void 0);
    return DragSettings;
}(ChildProperty));
export { DragSettings };
/**
 * Options to customize the center label of the pie and doughnut chart.
 *
 * @default {}
 */
var CenterLabel = /** @class */ (function (_super) {
    __extends(CenterLabel, _super);
    function CenterLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(null)
    ], CenterLabel.prototype, "text", void 0);
    __decorate([
        Complex({ fontFamily: null, size: "16px", fontStyle: 'Normal', fontWeight: '600', color: null }, Font)
    ], CenterLabel.prototype, "textStyle", void 0);
    __decorate([
        Property(null)
    ], CenterLabel.prototype, "hoverTextFormat", void 0);
    return CenterLabel;
}(ChildProperty));
export { CenterLabel };
/**
 * Configures the ToolTips in the chart.
 *
 * @public
 */
var TooltipSettings = /** @class */ (function (_super) {
    __extends(TooltipSettings, _super);
    function TooltipSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(false)
    ], TooltipSettings.prototype, "enable", void 0);
    __decorate([
        Property(true)
    ], TooltipSettings.prototype, "enableMarker", void 0);
    __decorate([
        Property(false)
    ], TooltipSettings.prototype, "shared", void 0);
    __decorate([
        Property(null)
    ], TooltipSettings.prototype, "fill", void 0);
    __decorate([
        Property(null)
    ], TooltipSettings.prototype, "header", void 0);
    __decorate([
        Property(null)
    ], TooltipSettings.prototype, "opacity", void 0);
    __decorate([
        Complex({ fontFamily: null, size: "12px", fontStyle: 'Normal', fontWeight: '400', color: null }, Font)
    ], TooltipSettings.prototype, "textStyle", void 0);
    __decorate([
        Property(null)
    ], TooltipSettings.prototype, "format", void 0);
    __decorate([
        Property(null)
    ], TooltipSettings.prototype, "template", void 0);
    __decorate([
        Property(true)
    ], TooltipSettings.prototype, "enableAnimation", void 0);
    __decorate([
        Property(300)
    ], TooltipSettings.prototype, "duration", void 0);
    __decorate([
        Property(1000)
    ], TooltipSettings.prototype, "fadeOutDuration", void 0);
    __decorate([
        Property('Move')
    ], TooltipSettings.prototype, "fadeOutMode", void 0);
    __decorate([
        Property(false)
    ], TooltipSettings.prototype, "enableTextWrap", void 0);
    __decorate([
        Property(true)
    ], TooltipSettings.prototype, "showNearestPoint", void 0);
    __decorate([
        Complex({ color: null, width: null }, Border)
    ], TooltipSettings.prototype, "border", void 0);
    return TooltipSettings;
}(ChildProperty));
export { TooltipSettings };
var StockTooltipSettings = /** @class */ (function (_super) {
    __extends(StockTooltipSettings, _super);
    function StockTooltipSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(false)
    ], StockTooltipSettings.prototype, "enable", void 0);
    __decorate([
        Property(true)
    ], StockTooltipSettings.prototype, "enableMarker", void 0);
    __decorate([
        Property(false)
    ], StockTooltipSettings.prototype, "shared", void 0);
    __decorate([
        Property(null)
    ], StockTooltipSettings.prototype, "fill", void 0);
    __decorate([
        Property(null)
    ], StockTooltipSettings.prototype, "header", void 0);
    __decorate([
        Property(0.75)
    ], StockTooltipSettings.prototype, "opacity", void 0);
    __decorate([
        Complex({ fontFamily: null, size: "12px", fontStyle: 'Normal', fontWeight: '400', color: null }, Font)
    ], StockTooltipSettings.prototype, "textStyle", void 0);
    __decorate([
        Property(null)
    ], StockTooltipSettings.prototype, "format", void 0);
    __decorate([
        Property(null)
    ], StockTooltipSettings.prototype, "template", void 0);
    __decorate([
        Property(true)
    ], StockTooltipSettings.prototype, "enableAnimation", void 0);
    __decorate([
        Property(300)
    ], StockTooltipSettings.prototype, "duration", void 0);
    __decorate([
        Property(1000)
    ], StockTooltipSettings.prototype, "fadeOutDuration", void 0);
    __decorate([
        Property('Move')
    ], StockTooltipSettings.prototype, "fadeOutMode", void 0);
    __decorate([
        Property(false)
    ], StockTooltipSettings.prototype, "enableTextWrap", void 0);
    __decorate([
        Property(true)
    ], StockTooltipSettings.prototype, "showNearestPoint", void 0);
    __decorate([
        Complex({ color: null, width: null }, Border)
    ], StockTooltipSettings.prototype, "border", void 0);
    __decorate([
        Property('Fixed')
    ], StockTooltipSettings.prototype, "position", void 0);
    return StockTooltipSettings;
}(ChildProperty));
export { StockTooltipSettings };
/**
 * button settings in period selector
 */
var Periods = /** @class */ (function (_super) {
    __extends(Periods, _super);
    function Periods() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('Years')
    ], Periods.prototype, "intervalType", void 0);
    __decorate([
        Property(1)
    ], Periods.prototype, "interval", void 0);
    __decorate([
        Property(null)
    ], Periods.prototype, "text", void 0);
    __decorate([
        Property(false)
    ], Periods.prototype, "selected", void 0);
    return Periods;
}(ChildProperty));
export { Periods };
/**
 * Period Selector Settings
 */
var PeriodSelectorSettings = /** @class */ (function (_super) {
    __extends(PeriodSelectorSettings, _super);
    function PeriodSelectorSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(43)
    ], PeriodSelectorSettings.prototype, "height", void 0);
    __decorate([
        Property('Bottom')
    ], PeriodSelectorSettings.prototype, "position", void 0);
    __decorate([
        Collection([], Periods)
    ], PeriodSelectorSettings.prototype, "periods", void 0);
    return PeriodSelectorSettings;
}(ChildProperty));
export { PeriodSelectorSettings };
